import { render, staticRenderFns } from "./AddUserBulk.vue?vue&type=template&id=55f7fb60&"
import script from "./AddUserBulk.vue?vue&type=script&lang=ts&"
export * from "./AddUserBulk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports